import React from 'react';
import SEOLandingPage from '../SEOLandingPage';
import { Cpu, Activity, Gamepad2, Settings } from 'lucide-react';

const BallSimulationPage: React.FC = () => {
  return (
    <SEOLandingPage 
      title="Ball Simulation Software"
      seoTitle="Ball Simulation & Physics Simulator"
      description="The ultimate ball simulation software for creators. Build complex physics-based ball simulations, satisfying loops, and rhythmic animations for TikTok and YouTube Shorts."
      keywords="ball simulation, ball simulator, physics simulator, bouncing ball simulation, satisfying physics, ball engine, fun circle games, funcirclegames, fun circle games creator studio"
      heroTitle="Professional Ball Simulation Engine"
      heroSubtitle="Create hyper-realistic, oddly satisfying ball simulations with our advanced physics engine. Perfect for viral content creators and digital artists."
      videoMeta={{
        name: "Professional Ball Simulation Showcase",
        description: "Watch how a single ball simulation can turn into an oddly satisfying physics loop with advanced gravity and collision settings.",
        thumbnailUrl: "https://funcirclegames.com/thumbnails/ball-sim-hero.jpg",
        uploadDate: "2026-05-19T12:00:00Z",
        contentUrl: "https://funcirclegames.com/videos/ball-sim-demo.mp4",
        embedUrl: "https://funcirclegames.com/embed/ball-sim-demo"
      }}
      features={[
        {
          title: "Advanced Physics",
          description: "Real-time collision detection, gravity control, and elasticity settings for perfect ball behavior.",
          icon: <Cpu className="w-6 h-6" />
        },
        {
          title: "Custom Materials",
          description: "Define ball density, friction, and visual textures to match any aesthetic or trend.",
          icon: <Settings className="w-6 h-6" />
        },
        {
          title: "Complex Containers",
          description: "Generate interactions within custom shapes, rotating rings, and dynamic environments.",
          icon: <Gamepad2 className="w-6 h-6" />
        },
        {
          title: "Live Tuning",
          description: "Adjust simulation parameters on the fly without restarting your render or loop.",
          icon: <Activity className="w-6 h-6" />
        }
      ]}
      contentSnippet="Our ball simulation software is designed from the ground up for the modern creator economy. Whether you're building a digital zen garden or a high-intensity 'escape' challenge, our engine provides the precision and visual fidelity required for million-view videos. With support for multiple ball types and container logic, the possibilities for satisfying content are truly endless."
      currentTool="/ball-simulation"
    />
  );
};

export default BallSimulationPage;
